/**
 * Deep O: a tall chute down the middle of the cave, four slime floors high, loaded at the top with
 * diamonds and boulders. Dig the row under its first floor and the load seeps down, floor by floor;
 * windows in the walls let you reach in on the way (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepO: CaveDef = {
  id: 'O',
  name: 'CASCADE',
  hint: 'Open the top of the chute, then catch what seeps down.',
  intermission: false,
  colors: [6, 15, 3],
  diamondValue: 28,
  extraValue: 55,
  fill: { base: '.', items: [['r', 12], ['d', 5]] },
  levels: [
    { seed: 6501, diamonds: 15, time: 150 },
    { seed: 6502, diamonds: 17, time: 140 },
    { seed: 6503, diamonds: 19, time: 130 },
    { seed: 6504, diamonds: 21, time: 120 },
    { seed: 6505, diamonds: 23, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W??????????????wdrdrdddrw??????????????W',
    'W.P.???????????wrdrdrdrdw??????????????W',
    'W...??????????..ddrdrdrrw??????????????W',
    'W??????????????wssssssssw??????????????W',
    'W?????????????............?????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????.        w??????????????W',
    'W??????????????wssssssssw??????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????w        .??????????????W',
    'W??????????????wssssssssw??????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????.        w??????????????W',
    'W??????????????wssssssssw??????????????W',
    'W??????????????w        w??????????????W',
    'W??????????????w        w??????????????W',
    'W...???????????w        w??????????????W',
    'W.X.???????????w        .??????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
